import { SimpleOrderInput } from 'models/order-input/simple-order';
import { createContext, Dispatch, SetStateAction } from 'react';

type SimpleOrderContextType = {
    order: SimpleOrderInput;
    setOrder: Dispatch<SetStateAction<SimpleOrderInput>>;
};
export const SimpleOrderContext = createContext<SimpleOrderContextType>({
    order: {} as SimpleOrderInput,
    setOrder: () => {
        return;
    },
});
